import styled from 'styled-components/macro';
import { GlobalColors } from 'src/App/Styles/Globals';
import { Platforms } from './Types/app.types';

export const AppContainer = styled.div<{ platform: Platforms }>`
	height: 100vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	background: ${GlobalColors.background80};
	color: ${GlobalColors.white1};
	overflow: hidden;

	${({ platform }) =>
		platform === Platforms.MOBILE
			? `
	`
			: platform === Platforms.PANEL
			? `
	`
			: platform === Platforms.COMPONENT
			? `
	`
			: platform === Platforms.VIDEO
			? `
		background: transparent;
		`
			: platform === Platforms.WEB
			? `
	`
			: ``}
`;
